// YERİ: src/app/domains/site/sections/about.section.ts
// Hakkımızda — iki sütun (metin + öne çıkanlar/görsel), tema-sürümlü.

import { Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';

@Component({
  selector: 'sec-about',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="about" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:px-8">
        <div [class.lg:order-2]="imageSide() === 'left'">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          <p class="mt-5 text-lg leading-relaxed text-neutral-600 dark:text-neutral-300">{{ body() }}</p>
          <ul class="mt-8 space-y-4">
            @for (p of points(); track p) {
              <li class="flex items-start gap-3">
                <span class="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full text-white" style="background-color:var(--site-primary)">
                  <m-icon name="check" size="xs" />
                </span>
                <span class="text-neutral-700 dark:text-neutral-300">{{ p }}</span>
              </li>
            }
          </ul>
        </div>
        <div class="relative" [class.lg:order-1]="imageSide() === 'left'">
          @if (imageUrl(); as img) {
            <img [src]="img" alt="" class="aspect-4/3 w-full rounded-2xl object-cover shadow-xl" />
          } @else {
            <div class="aspect-4/3 w-full rounded-2xl shadow-xl" style="background:linear-gradient(135deg,var(--site-primary),var(--site-primary-dark))"></div>
          }
          <div class="absolute -bottom-6 -left-6 hidden rounded-2xl bg-white p-6 shadow-lg dark:bg-neutral-900 sm:block">
            <p class="font-[family-name:var(--site-head-font)] text-4xl font-bold" style="color:var(--site-primary)">{{ badgeValue() }}</p>
            <p class="mt-1 text-sm text-neutral-500">{{ badgeLabel() }}</p>
          </div>
        </div>
      </div>
    </section>
  `,
})
export class AboutSection {
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Hakkımızda'));
  protected title = computed(() => cfg(this.config(), 'title', 'Adaletin Yanında, Müvekkilin Hizmetinde'));
  protected body = computed(() => cfg(this.config(), 'body', 'Büromuz, alanında uzman avukatlardan oluşan kadrosuyla yılların verdiği tecrübeyi modern hukuk anlayışıyla birleştirir. Her müvekkilimize özel strateji geliştirir, sürecin her aşamasında şeffaf iletişim kurarız.'));
  protected points = computed<string[]>(() => cfg<string[]>(this.config(), 'points', [
    'Uzman ve deneyimli avukat kadrosu',
    'Müvekkile özel hukuki strateji',
    'Şeffaf süreç ve düzenli bilgilendirme',
    'Gizlilik ve mesleki etik ilkeleri',
  ]));
  protected imageUrl = computed(() => cfg<string | null>(this.config(), 'imageUrl', null));
  protected imageSide = computed(() => cfg<string>(this.config(), 'imageSide', 'right'));
  protected badgeValue = computed(() => cfg(this.config(), 'badgeValue', '20+'));
  protected badgeLabel = computed(() => cfg(this.config(), 'badgeLabel', 'Yıllık Tecrübe'));
}
